import { useMutation } from "react-query";
import { changePassword } from "../api/user/changePassword";
import { queryClient } from "./transactionsStore";
import { USER_DETAILS_QUERY_KEY } from "./useQueryGetUser";

export function useMutationChangePassword() {
  return useMutation({
    mutationFn: changePassword,
    onSuccess: () => {
      queryClient.invalidateQueries([...USER_DETAILS_QUERY_KEY]);
    },
  });
}
